//@flow
import type { TableColumnTypes } from 'common/entity/generic/EntityImportContainer/types';
import ContactImportHelper from 'common/entity/contactMaster/ContactImportHelper';

const CONTACT_IMPORT_FORMAT: Array<TableColumnTypes> = [
    {
        titleKey: 'contactProperties.id',
        id: 'id',
        disabled: true,
        fixed: true,
        required: true,
        templateValue: 'masterImportTemplateValues.masterContact.id'
    },
    {
        titleKey: 'contactProperties.code',
        id: 'code',
        disabled: true,
        templateValue: 'masterImportTemplateValues.masterContact.code'
    },
    {
        titleKey: 'contactProperties.name',
        id: 'name',
        required: true,
        templateValue: 'masterImportTemplateValues.masterContact.name'
    },
    {
        titleKey: 'contactProperties.type',
        id: 'type',
        templateValue: 'masterImportTemplateValues.masterContact.type',
        required: true,
        processCell: ContactImportHelper.processContactType
    },
    {
        titleKey: 'contactProperties.company',
        id: 'company',
        templateValue: 'masterImportTemplateValues.masterContact.company'
    },
    {
        titleKey: 'contactProperties.teamId',
        id: 'teams',
        templateValue: 'masterImportTemplateValues.masterContact.teams',
        processCell: ContactImportHelper.processTeams,
        validateCell: ContactImportHelper.validateTeamIds,
        serializeCell: ContactImportHelper.serializeTeams
    },
    {
        titleKey: 'contactProperties.primaryMobileNumber',
        id: 'phoneNumber',
        required: true,
        templateValue:
            'masterImportTemplateValues.masterContact.primaryMobileNumber',
        accessor: ['phoneNumber', 'phoneNumber']
    },
    {
        titleKey: 'contactProperties.alternateMobileNumber',
        id: 'additionalPhoneNumbers',
        templateValue:
            'masterImportTemplateValues.masterContact.alternateMobileNumber',
        processCell: ContactImportHelper.processAdditionalPhoneNumbers,
        serializeCell: ContactImportHelper.serializeAdditionalPhoneNumbers,
        validateCell: ContactImportHelper.validateAdditionalPhoneNumbers
    },
    {
        titleKey: 'contactProperties.landlineNumber',
        id: 'landlineNumber',
        templateValue:
            'masterImportTemplateValues.masterContact.landlineNumber',
        accessor: ['landlineNumber', 'phoneNumber']
    },
    {
        titleKey: 'contactProperties.primaryEmailAddress',
        id: 'emailAddress',
        templateValue:
            'masterImportTemplateValues.masterContact.primaryEmailAddress',
        accessor: ['emailAddress', 'emailAddress'],
        validateCell: ContactImportHelper.validateEmailAddress
    },
    {
        titleKey: 'contactProperties.alternateEmailAddress',
        id: 'additionalEmailAddresses',
        templateValue:
            'masterImportTemplateValues.masterContact.alternateEmailAddress',
        processCell: ContactImportHelper.processAdditionalEmails,
        serializeCell: ContactImportHelper.serializeAdditionalEmails,
        validateCell: ContactImportHelper.validateAdditionalEmails
    }
];

export default CONTACT_IMPORT_FORMAT;
